<template>
    <div class="content">
        <div slot="header" class="clearfix">
             <span>饮品管理 <i class="el-icon-d-arrow-right"></i> 速率延时</span>
        </div>
        <div  class="content_bd">
            <el-row :gutter="24">
                <el-col :span="3" style="padding-left: 18px;">
                    <el-input placeholder="饮品名称"  size="small" v-model="beverageName"/>
                </el-col>
                <el-col :span="1">
                    <el-button type="primary" size="small" @click="query()"><i class="el-icon-search el-icon--left"></i>{{$t('search')}}</el-button>
                </el-col>
                <el-col :span="19" class="btn-right">
                    <el-button type="info" size="small" style="padding-right: 10px;position:absolute;right: 120px;" @click="add()"><i class="el-icon-circle-plus-outline el-icon--left"></i>{{$t('add')}}</el-button>
                    <el-button type="primary" size="small" style="padding-right: 10px;position:absolute;right: 25px;"><i class="el-icon-delete el-icon--left"></i>{{$t('delete')}}</el-button>
                </el-col>
            </el-row>

            <el-card  style="margin-top:18px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
                <!--<div slot="header" class="clearfix">
                    <span>设备列表</span>
                </div>-->
                <el-row>
                    <el-col :span="24">
                        <el-table
                        ref="multipleTable"
                        :data="speedList"
                        stripe
                        tooltip-effect="dark"
                        :page-size="pageSize"
                        :pager-count="11"
                        v-loading="speedListloading"
                        max-height="520"
                        >
                            <el-table-column
                                type="selection"
                                width="30">
                                </el-table-column>
                            <el-table-column
                                type="index"
                                :label="$t('serialNo')"
                                width="50">
                            </el-table-column>
                            <el-table-column
                                prop="drinkName"
                                label="饮品名称"
                                >
                                <template slot-scope="scope">
                                    <span  @click="handleTableItemClick(scope.row)" >{{scope.row.beverage == null ?'':scope.row.beverage.name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="materialImg"
                                :label="$t('surong.rawMaterialPicture')"
                                >
                                <template slot-scope="scope">
                                    <el-image @click="handleTableItemClick(scope.row)" :src="scope.row.beverage.rawMaterial.picture.path" style="width: 100px; height: 100px"></el-image>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="alarmExtensionValue"
                                label="报警延伸值"
                                >
                            </el-table-column>
                            <el-table-column
                                prop="checkTime"
                                label="校验时间"
                                >
                            </el-table-column>
                            <el-table-column
                                prop="powderOutletCloseRate"
                                label="出粉口关闭速率"
                                >
                            </el-table-column>
                            <el-table-column
                                prop="effluentRate"
                                label="出水速率（ml/s）"
                                >
                            </el-table-column>
                            <el-table-column
                                prop="powderOutRate"
                                label="出粉速率（g/s）"
                                sortable="sort"
                                >
                            </el-table-column>
                            <el-table-column
                                prop="powderOutDelay"
                                label="出粉延时（s）"
                                >
                            </el-table-column>
                            <el-table-column
                                prop="stirRate"
                                label="搅拌速率（%）"
                                >
                            </el-table-column>
                            <el-table-column
                                :label="$t('operation')"
                                fixed="right"
                                width="150"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" @click="updateEquip(scope.row)" size="small">编辑</el-button>
                                    <el-button type="text" @click="deleteSpeed(scope.row)" size="small">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="23" style="margin-top:2%;text-align:right">
                        <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage4"
                        :page-sizes="[10, 20,50,100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSpeedCount">
                        </el-pagination>
                    </el-col>
                    <el-col :span="1" style="margin-top:2%;">
                        <el-button size="mini" class="gobutton">GO</el-button>
                    </el-col>
                </el-row>
            </el-card>

            <!-- 速率延时添加 -->
            <el-dialog
            title="速率延时"
            :visible.sync="formulaDialogVisible"
            :close-on-click-modal="false"
            style="text-align: left;"
            :append-to-body="true"
            >
            <el-card  style="padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
                <el-form style="margin: 10px 10px 10px 10px;" class="table">
                    <el-row :gutter="24" style="text-align: center;margin: 15px 0px 15px 0px;">
                        <el-col :span="10">
                            <el-form-item label="饮品名称： " label-width="130px">
                                <el-select class="dialog_item_element" v-model="addparam.beverageID" placeholder="请选择饮品名称" >
                                  <el-option v-for="(item,index) in cupTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                      <el-col :span="10" :offset="2">
                        <el-form-item label="搅拌速率（%）"  label-width="130px"><el-input v-model="addparam.stirRate" placeholder="" ></el-input></el-form-item>
                      </el-col>
                    </el-row>
                    <el-row  :gutter="24" style="text-align: center;margin: 15px 0px 15px 0px;">
                        <el-col :span="10">
                            <el-form-item label="报警延伸值： " label-width="130px"><el-input v-model="addparam.alarmExtensionValue" placeholder="" ></el-input></el-form-item>
                        </el-col>
                        <el-col :span="10" :offset="2">
                            <el-form-item label="校验时间：" label-width="130px">
                                <el-input v-model="input" :placeholder="addparam.checkTime"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row  :gutter="24" style="text-align: center;width: 100%;margin: 15px 0px 15px 0px;">
                        <el-col :span="10">
                            <el-form-item label="出粉口关闭速率： " label-width="130px"><el-input v-model="addparam.powderOutletCloseRate" placeholder=""></el-input></el-form-item>
                        </el-col>
                        <el-col :span="10" :offset="2">
                            <el-form-item label="出水速率（g/s）" label-width="130px"><el-input v-model="addparam.effluentRate" placeholder=""></el-input></el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24" style="text-align: center;margin: 15px 0px 15px 0px;">
                        <el-col :span="10">
                           <el-form-item label="出粉速率（g/s）" label-width="130px"><el-input v-model="addparam.powderOutRate" placeholder=""></el-input></el-form-item>
                        </el-col>
                        <el-col :span="10" :offset="2">
                            <el-form-item label="出粉延时（s）" label-width="130px"><el-input v-model="addparam.powderOutDelay" placeholder=""></el-input></el-form-item>
                        </el-col>
                    </el-row>

                </el-form>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button @click="formulaDialogVisible = false">{{$t('cancel')}}</el-button>
                <el-button type="primary" style="margin-left: 15px;color: #eceeef;background-color: #315a7d;" @click="addSpeed()">{{$t('okSpace')}}</el-button>
            </span>
        </el-dialog>


            <!-- 速率延时编辑 -->
            <el-dialog
            title="编辑速率延时"
            :visible.sync="editDialogVisible"
            :close-on-click-modal="false"
            style="text-align: left;"
            :append-to-body="true"
            >
            <el-card  style="padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
                <el-form style="margin: 10px 10px 10px 10px;" class="table">
                    <el-row  :gutter="24" style="text-align: center;margin: 15px 0px 15px 0px;">
                        <el-col :span="10">
                            <el-form-item label="饮品名称： " label-width="130px">
                              <el-select class="dialog_item_element" v-model="updateparam.beverageID" placeholder="请选择饮品名称" >
                                <el-option v-for="(item,index) in cupTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
                              </el-select>
                            </el-form-item>
                        </el-col>
                      <el-col :span="10" :offset="2">
                        <el-form-item label="搅拌速率（%）"  label-width="130px"><el-input v-model="updateparam.stirRate" ></el-input></el-form-item>
                      </el-col>
                    </el-row>
                    <el-row  :gutter="24" style="text-align: center;margin: 15px 0px 15px 0px;">
                        <el-col :span="10">
                            <el-form-item label="报警延伸值： " label-width="130px"><el-input v-model="updateparam.alarmExtensionValue" ></el-input></el-form-item>
                        </el-col>
                        <el-col :span="10" :offset="2">
                            <el-form-item label="校验时间：" label-width="130px">
                               <el-input v-model="updateparam.checkTime"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row  :gutter="24" style="text-align: center;width: 100%;margin: 15px 0px 15px 0px;">
                        <el-col :span="10">
                            <el-form-item label="出粉口关闭速率： " label-width="130px"><el-input v-model="updateparam.powderOutletCloseRate"></el-input></el-form-item>
                        </el-col>
                        <el-col :span="10" :offset="2">
                            <el-form-item label="出水速率（g/s）" label-width="130px"><el-input v-model="updateparam.effluentRate"></el-input></el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24" style="text-align: center;margin: 15px 0px 15px 0px;">
                        <el-col :span="10">
                           <el-form-item label="出粉速率（g/s）" label-width="130px"><el-input v-model="updateparam.powderOutRate"></el-input></el-form-item>
                        </el-col>
                        <el-col :span="10" :offset="2">
                            <el-form-item label="出粉延时（s）" label-width="130px"><el-input v-model="updateparam.powderOutDelay"></el-input></el-form-item>
                        </el-col>
                    </el-row>

                </el-form>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">{{$t('cancel')}}</el-button>
                <el-button type="primary" style="margin-left: 15px;color: #eceeef;background-color: #315a7d;" @click="putSpeedData()  ">{{$t('okSpace')}}</el-button>
            </span>
        </el-dialog>


        </div>
    </div>
</template>

<script>
export default {
    name:"speeddelay",
    data(){
        return {
            formLabelWidth:'120',
            pageSize:8,
            FilterTime:'',
            beverageName:'',
            editDialogVisible:false,
            formulaDialogVisible:false,
            input:'',
            imageUrl:'',
            value1: '',
            currentPage4:1,
            speedListloading:true,
            totalSpeedCount:0,
            pageSize:10,
            pageIndex:1,
            order:'',
            sequence:true,
            speedList:[],
            param:new Object(),
            queryparam:new Object(),
            addparam:new Object(),
            updateparam:{},
            equipmentList:[],
            cupTypeList:[]
        }
    },
    created() {
    },
    mounted(){
      this.loadCupTypeList()
    },
    methods:{
        add(){
          this.formulaDialogVisible = true
          this.addparam = {}
        },
        loadCupTypeList(){
          this.$httpservice.get("api/Beverage/CupTypes", { pageIndex:0,pageSize:1000,}).then(
            (data)=> {
              if(data.body.code=="200"){
                this.cupTypeList = data.body.data;
                this.loadSpeedList();
              }else{
                this.$message({
                  message: data.body.msg,
                  type: 'warning'
                });
              }
            },
             (data)=> {
              this.Beverageloading= false;
              let statusCode = data.status;
              this.$message({
                message: this.$t('queryFailedStatusCode')+statusCode,
                type: 'warning'
              });
            }
          );
        },
        handleTableItemClick(e){

        },
        resize(){
          var scale = 1
          scale = (window.innerWidth-20)/1900
          document.body.style.width = '1900px'
          document.body.style.transform = `scale(${scale})`
          document.body.style.transformOrigin = `0 0`
          document.body.style.height = `${100/scale}%`
        },
        goTo(index){
            //直接跳转
            this.$router.push("/home/"+index);
        },
        handleSizeChange(e){
            this.pageSize=e;
            this.loadSpeedList();
        },
        handleCurrentChange(e){
            this.pageIndex = e;
            this.loadSpeedList();
        },
        //点击查询
        query(){
            this.speedListloading = true;
            this.loadSpeedList({beverageName:this.beverageName});
        },
        //清空筛选及排序
        clear(){
            this.$refs.multipleTable.clearSort();
            this.$refs.multipleTable.clearFilter();
            this.loadSpeedList();
        },
        //加载速率延时列表
        loadSpeedList(parameter){
            this.param = {
                pageIndex:this.pageIndex,
                pageSize:this.pageSize,
                ...parameter
            };
            let that = this;
            this.$httpservice.get("api/RateDelay/List",that.param).then(
                function (data) {
                    that.speedListloading = false;
                    if(data.body.code=="200"){
                        that.speedList = data.body.data;
                        that.totalSpeedCount = data.body.totalCount;
                    }else{
                        that.$message({
                            message: data.body.msg,
                            type: 'danger'
                        });
                    }
                },
                function (data) {
                    that.speedListloading = false;
                    let statusCode = data.status;
                    that.$message({
                        message: that.$t('queryFailedStatusCode')+statusCode,
                        type: 'warning'
                    });
                }
            );
        },
        //新增速率接口
        addSpeed(){
            if(this.addparam.beverageID ){
                let that = this;
                this.$httpservice.post("api/RateDelay/Post",this.addparam).then(
                    function (data) {
                        if(data.body.code=="200"){
                            that.$message({
                                    message: that.$t('equipmentmanagement.successfullyAddedEquipment'),
                                    type: 'success'
                            });
                            that.formulaDialogVisible = false;
                          that.loadSpeedList();
                        }else{
                            that.$message({
                                message: data.body.msg,
                                type: 'danger'
                            });
                        }
                    },
                    function (data) {
                        let statusCode = data.status;
                        that.$message({
                            message: that.$t('queryFailedStatusCode')+statusCode,
                            type: 'warning'
                        });
                    }
                );
            }else{
               this.$message({
                    message: this.$t('equipmentmanagement.pleaseCompleteTheEquipmentInformation'),
                    type: 'warning'
                });
            }
        },
        //打包修改数据
        updateEquip(e){
            this.editDialogVisible = true;
            this.updateparam = {
              stirRate:'',
              beverageID:'',
              alarmExtensionValue:'',
              checkTime:'',
              powderOutletCloseRate:'',
              effluentRate:'',
              powderOutRate:'',
              powderOutDelay:''
            }
            this.updateparam.id = e.id;
            this.updateparam.beverageID = e.beverage.id;
            this.updateparam.alarmExtensionValue = e.alarmExtensionValue;
            this.updateparam.checkTime = e.checkTime;
            this.updateparam.powderOutletCloseRate = e.powderOutletCloseRate;
            this.updateparam.effluentRate = e.effluentRate;
            this.updateparam.powderOutRate = e.powderOutRate;
            this.updateparam.powderOutDelay = e.powderOutDelay;
            this.updateparam.stirRate = e.stirRate;
        },
        //修改数据接口
        putSpeedData(){
            if(this.updateparam.beverageID){
                let that = this;
                this.$httpservice.put("api/RateDelay/Put",this.updateparam).then(
                    function (data) {
                        if(data.body.code=="200"){
                            that.$message({
                                    message: that.$t('equipmentmanagement.editEquipmentSuccessfully'),
                                    type: 'success'
                            });
                            that.editDialogVisible = false;
                            that.loadSpeedList();
                        }else{
                            that.$message({
                                message: data.body.msg,
                                type: 'danger'
                            });
                        }
                    },
                    function (data) {
                        let statusCode = data.status;
                        that.$message({
                            message: that.$t('queryFailedStatusCode')+statusCode,
                            type: 'warning'
                        });
                    }
                );
            }else{
               this.$message({
                    message: this.$t('stc.pleaseCompleteTheChannelInformation'),
                    type: 'warning'
                });
            }
        },
        //删除记录
        deleteSpeed(data){
            let that = this;

            this.$httpservice.delete("api/RateDelay/Delete",{id:data.id}).then(
                function (data) {
                    that.speedListloading = false;
                    if(data.body.code=="200"){
                        that.loadSpeedList(that.param)
                        that.$message({
                            message: that.$t('deleteSuccessfully'),
                            type: 'success'
                        });
                    }else{
                        that.$message({
                            message: data.body.msg,
                            type: 'danger'
                        });
                    }
                },
                function (data) {
                    that.speedListloading = false;
                    let statusCode = data.status;
                    that.$message({
                        message: that.$t('queryFailedStatusCode')+statusCode,
                        type: 'warning'
                    });
                }
            );
        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
            this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        //监听排序
        sortChange({ prop, order }){
            let sequence=true;
            if(order == "ascending"){
                sequence=true;
            }else{
                sequence=false;
            }
            this.loadSpeedList({order:prop,sequence:sequence});
        },
    }
}
</script>
<style>
  .mypopper .el-image{
    border: 1px solid #ddd;
  }
  .mypopper .avatar-uploader-icon{
    width: 83px!important;
    height: 83px!important;
    line-height: 83px!important;
    border: 1px solid #ddd;
  }

</style>
<style scoped>
 .dialog-footer{
     padding: 0px 15px 25px 25px;;
 }

a:-webkit-any-link {
    color: #000000;
}

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .table .el-form-item{
    margin-bottom: 0px!important;
  }
  .table .tr {
    width: 100%;
    height: 147px;
  }
  .table .td {
    display: table;
  }
  .table .tr .el-form-item{
    display: table-cell;
    vertical-align: middle;
    width: 100%;
  }
.el-popover__reference .el-form-item__content .el-image{border:solid 1px #C0C4CC;position:relative;left:-65px;border-radius:5px;}
.is-always-shadow .el-form .el-form-item{
    display:  block;
    vertical-align: middle;}

.is-always-shadow  .el-col-8 .el-form-item{
    display: block;
    vertical-align: middle;}
.mypopper .el-image:hover{border:solid 1px #9fb3c2; box-shadow:0px 0px 6px #bababa; background:rgba(220,224,230,0.3);}
</style>



// WEBPACK FOOTER //
// src/pages/speeddelay/speeddelay.vue